<template>
  <div class="expressHistory">
    <div class="board">
      <div @click="goBack"><van-icon name="arrow-left" />返回</div>
      <div v-if="list.length > 0" class="expressList">
        <van-steps direction="vertical" :active="0">
          <div v-for="(item, index) in list" :key="index">
            <van-step v-if="index === 0">
              <template v-slot:active-icon>
                <div class="active-icon"></div>
              </template>
              <div>
                <span class="fs-16 fw-5" style="color: #41ba9e">{{
                  item.scanType
                }}</span>
                <span style="color: #41ba9e">{{ item.opTime }}</span>
              </div>
              <p style="color: black">{{ item.memo }}</p>
            </van-step>
            <van-step v-else>
              <template v-slot:inactive-icon>
                <div class="inactive-icon"></div>
              </template>
              <div>
                <span class="fs-16 fw-5" style="color: #999">{{
                  item.scanType
                }}</span>
                <span style="color: #999">{{ item.opTime }}</span>
              </div>
              <p style="color: #999">{{ item.memo }}</p>
            </van-step>
          </div>
        </van-steps>
      </div>
      <div v-else class="noExpress">
        <h3 class="noExpress_text">暂无物流信息</h3>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import { toEntry, getExactTime } from "@/core/utils/utils";

export default {
  name: "expressHistory",
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      const expressNum = this.$store.state.expressHistory.expressNum ?? "";
      //777031922725111
      this.$store
        .dispatch({
          type: "expressHistory/history",
          payload: {
            list: [expressNum],
          },
        })
        .then((data) => {
          const { code, msg, result } = data;
          // console.log(data);
          if (code === "0") {
            if (result.length !== 0) {
              this.list = result[0].list.reverse();
            }
          } else {
            this.$toast.fail(msg);
          }
        })
        .catch((e) => {
          this.$toast.fail("接口请求失败");
        });
    },
    formatDate(value) {
      return value ? getExactTime(value) : "";
    },
    goBack() {
      this.$router.back(-1);
    },
    doCopy(text) {
      this.$copyText(text).then(
        function (e) {
          Toast.success("复制成功");
          // console.log(e)
        },
        function (e) {
          Toast.fail("复制失败");
          console.log(e);
        }
      );
    },
  },
  beforeDestroy() {
    localStorage.removeItem("exchangeList");
  },
};
</script>
<style lang="scss">
.expressHistory {
  padding: 20px 0;
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #dff7ee 0%, #bfefdb 100%);
  box-sizing: border-box;
  .board {
    min-width: 90%;
    max-width: 351px;
    height: auto;
    min-height: 570px;
    max-height: 100%;
    background: #fcfbf1;
    border-radius: 8px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    padding: 20px 18px;
    box-sizing: border-box;
    .expressList {
      margin-top: 18px;
      max-height: 80%;
      overflow: scroll;
      .van-steps {
        background-color: #fcfbf1;
        .van-step__line {
          background-color: #ccc;
          width: 1px;
        }
      }
      h3 {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 23px;
      }
      .active-icon {
        width: 7px;
        height: 7px;
        border-radius: 50% 50%;
        background: #41ba9e;
      }
      .inactive-icon {
        width: 5px;
        height: 5px;
        border-radius: 50% 50%;
        background: #ccc;
      }
    }
    .noExpress {
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 570px;
      .noExpress_text {
        width: 96px;
        height: 23px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 23px;
      }
    }
  }
}
</style>

